import { Component } from 'react'
import { MainContainer } from './fader_styles'

export default class Fader extends Component {
  constructor(props) {
    super(props)
    this.state = { index: 0 }
  }

  next() {
    this.setState(state => ({ index: (state.index + 1) % this.props.children.length }))
  }

  prev() {
    this.setState(state => ({ index: (state.index - 1 + this.props.children.length) % this.props.children.length }))
  }

  render() {
    return (
      <MainContainer index={this.state.index} className={this.props.className} style={this.props.style}>
        {this.props.children}
      </MainContainer>
    )
  }
}
